import { Currency } from "src/utils/localization/currency";

export type FYCQuery = string & { _type: "FYCQuery" };

export default class FYCQueryBuilder {
  conditions: string[] = [];

  constructor(initialQuery?: FYCQuery) {
    if (initialQuery) this.appendAndCondition(initialQuery);
  }

  filterByCruiseCodes(cruiseCodes: string[]): FYCQueryBuilder {
    const cruiseCodesQuery = cruiseCodes.map((c) => `cruiseCode:"${c}"`);
    this.appendAndCondition(this.orConditions(cruiseCodesQuery));

    return this;
  }

  filterByDestinationId(destinationId: number | undefined): FYCQueryBuilder {
    if (!destinationId) return this;
    return this.filterByDestinationIds([destinationId]);
  }

  filterByDestinationIds(destinationIds: number[]): FYCQueryBuilder {
    const destinationIdsQuery = destinationIds.map(
      (id) => `destinationId:${id}`
    );
    this.appendAndCondition(this.orConditions(destinationIdsQuery));

    return this;
  }

  filterByShipName(shipName: string | undefined): FYCQueryBuilder {
    if (!shipName) return this;

    return this.filterByShipsName([shipName]);
  }

  filterByShipsName(shipNames: string[]): FYCQueryBuilder {
    const shipNamesQuery = shipNames.map(
      (name) => `content.shipName:"${name}"`
    );
    this.appendAndCondition(this.orConditions(shipNamesQuery));

    return this;
  }

  filterByCruiseType(cruiseType: string): FYCQueryBuilder {
    return this.filterByCruiseTypes([cruiseType]);
  }

  filterByCruiseTypes(cruiseTypes: string[]): FYCQueryBuilder {
    const cruiseTypesQuery = cruiseTypes.map((type) => `cruiseType:"${type}"`);
    this.appendAndCondition(this.orConditions(cruiseTypesQuery));

    return this;
  }

  filterByComboType(comboType: string): FYCQueryBuilder {
    return this.filterByComboTypes([comboType]);
  }

  filterByComboTypes(comboTypes: string[]): FYCQueryBuilder {
    const comboTypesQuery = comboTypes.map((type) => `comboType:"${type}"`);
    this.appendAndCondition(this.orConditions(comboTypesQuery));

    return this;
  }

  filterByPorts(portCodes: string[]): FYCQueryBuilder {
    const portsQuery = portCodes.map((portCode) => `portCodes:"${portCode}"`);
    this.appendAndCondition(this.orConditions(portsQuery));

    return this;
  }

  onlyVisibleCruises(): FYCQueryBuilder {
    this.appendAndCondition("(visible:true)");
    return this;
  }

  onlyVisibleForCurrency(currency: Currency): FYCQueryBuilder {
    if (process.env.GATSBY_SHOW_ALL_FUTURE_CRUISES != "true") {
      this.appendAndCondition(`(cruiseAvailable_${currency}:true)`);
    }
    return this;
  }

  onlyFutureCruises(): FYCQueryBuilder {
    const today = new Date();
    const todayFilter = Math.floor(today.setHours(0, 0, 0, 0) / 1000);
    const query = `(departureTimestamp >= ${todayFilter})`;
    this.appendAndCondition(query);
    return this;
  }

  private appendAndCondition(condition: string) {
    this.conditions.push(condition);
  }

  private orConditions(conditions: string[]) {
    return `(${conditions.join(" OR ")})`;
  }

  generate(): FYCQuery {
    return this.conditions.join(" AND ") as FYCQuery;
  }
}
